export default __webpack_public_path__ + "static/media/easy_car_shopping.6f377d8b.svg";